module.exports = __webpack_public_path__ + "media/compitienda_V1.55a7b538.mp4";